module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }